import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AppService} from '../../app.service';

export enum ResultBaseEnum {
  '/contacto-hola' = '¿De qué te interesa hablar? *',
  '/contacto-proyecto' = 'Empresa *',
  '/contacto-trabajo' = '¿Qué tipo de puesto te interesa? *',
}

export enum idBaseEnum {
  '/contacto-hola' = 'off',
  '/contacto-proyecto' = 'proyects',
  '/contacto-trabajo' = 'workers',
}

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html'
})
export class FormComponent implements OnInit {
  public form: FormGroup;
  public send = 0;
  public resultBase: string;
  // private router: Router
  constructor(private http: HttpClient,
              public appService: AppService) {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [
        Validators.required,
        Validators.email
      ]),
      phone: new FormControl('', [
        Validators.maxLength(9),
        Validators.minLength(7),
        Validators.pattern(/^[0-9]{9}?$/)
      ]),
      enterprise: new FormControl('', Validators.required),
      msg: new FormControl(''),
      checkbox: new FormControl('', Validators.required),
      id: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.send = 0;
    this.resultBase = ResultBaseEnum[this.appService.base];
  }

  public sendData() {
    if (this.form.get('checkbox').value === true) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'});
      const url = './assets/library/sendMail.php';
      // const url = 'https://www.digboost.com/new/sendMail.php';
      const data = this.form.value;
      data.id = idBaseEnum[this.appService.base];
      this.http.post(url, data, {headers}).subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        data => {
          this.form.reset(true);
          this.send = 1;
        },
        error => this.send = 2
      );
    }
  }
}
